export default [
  {
    path: '/activity-newgrade/index',
    name: 'index',
    component: () => import('@/views/activity-newgrade/index'),
    meta: {
      title: '新高三钜惠，开学福利送不停'
    }
  },
  
]
